<template>
  <footer class="footer ">
    <div class="container">
      <div class="clearfix">
        <div class="row">
          <div class="col-sm-9">
            <div class="clearfix">
              <h3 class="section-heading footer-heading-text ">
                {{$t("general.footer-title")}}
              </h3>
            </div>
            <div class="divider"></div>
            <div class="clearfix footer-links-groups">
              <span class="footer-links-groups--row">
                <div class="footer-links-group">
                  <h4 class="footer-links-group-heading">{{$t('general.trade')}}</h4>
                  <ul class="footer-links-list">
                    <li><a href="/trading">Access trade area</a></li>
                    <li><router-link to="/trade/trading-platforms">{{$t('general.trading-platforms')}}</router-link></li>
                     <!-- <li><router-link to="/trade/option-types">{{$t('general.option-types')}}</router-link></li>-->
                    <li><router-link to="/trade/trade-conditions">{{$t('general.trading-conditions')}}</router-link></li>
                    <li><a href="/asset">{{$t('general.option-schedule')}}</a></li>
                  </ul>
                </div>
                <div class="footer-links-group">
                  <h4 class="footer-links-group-heading"> {{$t('general.bi-winning')}} </h4>
                  <ul class="footer-links-list">
                    <li><router-link to="/overview">{{$t('general.bi-winning-overview')}}</router-link></li>
                    <!--<li><router-link to="/why-trade">{{$t('general.why-trade')}}</router-link></li>-->
                    <li><router-link to="/banking">{{$t('general.banking')}} </router-link></li>
                    <!--  <li><router-link to="/points">{{$t('general.points')}}</router-link></li>
                    <li><router-link to="/company">{{$t('general.company')}}</router-link></li>-->
                   <!-- <li><router-link to="/help-and-support">{{$t('general.help-and-support')}}</router-link></li>-->
                  </ul>
                </div>
                <div class="footer-links-group">
                  <h4 class="footer-links-group-heading"> {{$t('general.resources')}} </h4>
                  <ul class="footer-links-list">
                   <!-- <li><router-link to="/resources/faq"> {{$t('general.faq')}} </router-link></li>-->
                    <li><a href="/trading">{{$t('general.quick-demo')}}</a>
                    </li>
                  </ul>
                </div>
                <div class="footer-links-group">
                   <h4 class="footer-links-group-heading">{{$t('general.members')}}</h4>
                  <ul class="footer-links-list">
                    <template v-if="!$cookie.get('userID')">
                    <li><a href="/login">{{$t('general.login')}}</a></li>
                    </template>
                    <template v-else>
                      <li><a href="/account">{{$t('general.my-account')}}</a></li>
                      <li><a href="/transaction">{{$t('general.transaction')}}</a></li>
                      <li><a href="/deposit">{{$t('general.deposit')}}</a></li>
                      <li><a href="/withdraw">{{$t('general.widthdraw')}}</a></li>
                    </template>
                  </ul>
                </div>
              </span>
            </div>
          </div>
          <div class="col-sm-3">
            <a href="https://partners.bi-winning.org/" class="affiliates-login-link reach-left-double clearfix">
              <span class="affiliates-login-text">{{$t('general.affiliate-login')}}</span>
              <span class="icon-wrapper">
                <span class="icon user-circle-grey-md"></span>
              </span>
            </a>
            <div class="affiliates-login reach-left-double"></div>
            <div class="divider reach-left-double"></div>
           <!-- <div class="download-mobile reach-left-double">
              <h3 class="download-mobile-heading ">{{$t('general.trade-on-mobile')}}</h3>

              <router-link to="/trade/trading-platforms" class="download-mobile-cta-link" >
                <div class="download-mobile-cta">
                  <img data-src="@/assets/images/footer-mob-device.png"
                    src="@/assets/images/footer-mob-device.png"><span
                    class="download-mobile-cta-text">{{$t('general.learn-more')}}</span><span class="download-mobile-cta-text-mob">{{$t('general.trade-on-mobile')}}</span>
                </div>
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
      <div class="disclaimer">
        <div class="section-heading disclaimer-heading">{{$t("general.disclaimer-title")}}</div>
        <div v-html="$t('general.disclaimer-text')"></div>
      </div>
      <div class="footer-terms-and-agreements">
        <a class="highlight" href="/#/terms-of-service">{{$t('general.terms-and-agreements')}}</a>
        <span  class="line">|</span>
        <a class="highlight" href="/#/privacy-policy">{{$t('general.policy')}}</a>
         <!-- </div> -->
        <!--<router-link to="/terms-of-service">{{$t('general.terms-and-agreements')}}</router-link> -->
        <span class="footer-copyright">{{$t('general.copyright')}}</span>
      </div>
    </div>
  </footer>
</template>

<style>
 .line{
   font-size:17px;
   padding-left:5px;
   padding-right:5px;
   color:#686867
 }
</style>

<script>
  export default {
    name: "Footer",
  }
</script>